import React from 'react';
import { LoginForm } from './LoginForm';
import { StarryBackground } from './StarryBackground';

const AuthLayout: React.FC = () => {
  return (
    <div className='relative flex min-h-screen items-center justify-center overflow-hidden p-4'>
      {/* Animated starry background */}
      <StarryBackground />

      {/* Glassmorphism login container */}
      <div className='relative z-10 w-full max-w-md'>
        <div className='bg-white/3 overflow-hidden rounded-2xl border border-white/5 shadow-2xl backdrop-blur-sm'>
          {/* Subtle gradient overlay */}
          <div className='from-white/2 pointer-events-none absolute inset-0 bg-gradient-to-br to-transparent'></div>

          {/* Content */}
          <div className='relative p-8'>
            <LoginForm />
          </div>
        </div>

        {/* Floating tech elements around the form */}
        <div className='absolute -left-4 -top-4 h-8 w-8 animate-pulse rounded-full border border-cyan-400/30'></div>
        <div className='absolute -right-6 -top-2 h-4 w-4 animate-bounce rounded-full bg-blue-400/20' style={{ animationDelay: '0.5s' }}></div>
        <div
          className='absolute -bottom-6 -left-2 h-6 w-6 rotate-45 animate-spin rounded-sm border border-purple-400/30'
          style={{ animationDuration: '8s' }}
        ></div>
        <div className='absolute -bottom-4 -right-4 h-5 w-5 animate-ping rounded-full bg-cyan-400/20' style={{ animationDelay: '1s' }}></div>
      </div>
    </div>
  );
};

export default AuthLayout;
